import React from 'react';
import styled from 'styled-components';
import { P, spacingHelper } from '@construct-kit/core';
import Link from '../../../shared/components/Link';
import type { ExploreOthersObject } from '../constants/exploreOthers';
import trackingAdapter from '../tracking/trackingAdapter';

const ImgBox = styled.article`
  width: 16.75rem;
`;

const Image = styled.img`
  height: 9rem;
  border-radius: ${({ theme }) => theme.border.radius.large};
`;

const PlainLink = styled(Link)`
  display: inline-block;
  color: inherit;

  @media (hover: hover) {
    &:hover {
      text-decoration: none;
    }
  }
`;

const Description = styled(P)`
  font-size: 16px;
  font-weight: ${({ theme }) => theme.typography.body01.fontWeight};
  margin-top: ${spacingHelper('small')};
`;

export type ExploreOthersItemProps = {
  exploreOthersObject: ExploreOthersObject;
};

const ExploreOthersItem: React.FunctionComponent<ExploreOthersItemProps> = ({
  exploreOthersObject,
}) => {
  const trackExploreOthersItemClick = () => {
    trackingAdapter.trackExploreOthersItemClick({ exploreOthersId: exploreOthersObject.id });
  };

  return (
    <PlainLink
      href={exploreOthersObject.url}
      aria-label={exploreOthersObject.displayText}
      onClick={trackExploreOthersItemClick}
    >
      <ImgBox>
        <Image src={`${exploreOthersObject.bgImg}.jpg?v=4`} alt={exploreOthersObject.displayText} />
        <Description>{exploreOthersObject.displayText}</Description>
      </ImgBox>
    </PlainLink>
  );
};

export default ExploreOthersItem;
